import classnames from 'classnames'
import { Link } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem } from '@appkit4/react-components/breadcrumb'
import styles from './index.module.css'

export const View = ({ itemList, className, ...props }) => {
    return (
        <Breadcrumb className={classnames(className, styles.default)} {...props}>
            {itemList?.map(({ link, text }) => {
                return <BreadcrumbItem key={text}>{link ? <Link to={link}>{text}</Link> : text}</BreadcrumbItem>
            })}
        </Breadcrumb>
    )
}
